import http_config from '../../common/config/http_config';
import axiosInstance from '../../common/helper/axiosInterceptor';
import { ParentDataModel, ParentResponseModel } from './parent.model';

export const onGetParents = (page: number, limit: number): Promise<ParentDataModel> => {
  return axiosInstance.get(
    http_config.BASE_URL + '/parent?page=' + page + '&limit=' + limit + '&delay=1',
  );
};

export const onSetParents = (payload: ParentResponseModel): Promise<ParentResponseModel> => {
  return axiosInstance.post(http_config.BASE_URL + '/parent', payload);
};

export const getStudentParents = async (studentId: string) => {
  return axiosInstance.get(http_config.BASE_URL + `/student/${studentId}/parents`);
};
